import {FormControl, InputLabel, MenuItem, Select} from "@material-ui/core"
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown"
import React from "react"

/**
 * A selector to specify a person's Document Type.
 *
 * @param documentTypes: {Object} Map containing all the values of the possible document types.
 * @param documentType: {String} The value of the selected document type.
 * @param label: {String} The text labeling (or giving a title to) the selector itself.
 * @param classes: {Object} Contains the JSS classes definitions for the selector.
 * @param tabIndex: {Number} Represents the order in the tab strokes.
 * @param id: {String} The unique identifier to put the input.
 * @param changeDocumentType: {Function} The event handler that is used to notify that a different document type has
 * been selected.
 */
const DocumentTypeSelector = ({
                                  documentTypes,
                                  documentType = documentTypes.DNI,
                                  label = "Tipo de documento",
                                  classes = {},
                                  tabIndex = 1,
                                  id = 'documentType',
                                  changeDocumentType = event => null
                              }) => (
    <FormControl className={classes.documentTypeContainer}>
        <InputLabel htmlFor="documentType">{label}</InputLabel>

        <Select
            onChange={changeDocumentType}
            value={documentType}
            IconComponent={KeyboardArrowDown}
            inputProps={{
                name: 'documentType',
                id,
                tabIndex
            }}>
            <MenuItem value={documentTypes.DNI}>DNI</MenuItem>
            <MenuItem value={documentTypes.LE}>L.E.</MenuItem>
            <MenuItem value={documentTypes.LC}>L.C.</MenuItem>
            <MenuItem value={documentTypes.IDENTIFICATION_CARD}>Cédula de Identidad</MenuItem>
            <MenuItem value={documentTypes.PASSPORT}>Pasaporte</MenuItem>
        </Select>
    </FormControl>
)

export default DocumentTypeSelector
